import { useMemo } from 'react';
import http from 'hub-http/clients/apiClient';
import { registerQuery, useQuery } from 'data-fetching-client';
import { USER_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { captureException } from '../utils/sentryUtils';
const APP_HUB_USERS_FIELD = 'usersData';
const FETCH_APP_HUB_USERS = registerQuery({
  fieldName: APP_HUB_USERS_FIELD,
  args: ['userIds'],
  fetcher: ({
    userIds
  }) => http.post('crm-search/search', {
    data: {
      count: userIds.length,
      objectTypeId: USER_TYPE_ID,
      requestOptions: {
        properties: ['hs_email', 'hs_given_name', 'hs_family_name', 'hs_internal_user_id']
      },
      filterGroups: [{
        filters: [{
          property: 'hs_internal_user_id',
          operator: 'IN',
          values: userIds
        }]
      }]
    }
  })
});
export const useAppHubUsers = userIds => {
  const {
    data,
    loading,
    error
  } = useQuery(FETCH_APP_HUB_USERS, {
    variables: {
      userIds
    },
    skip: userIds.length === 0,
    onError: err => {
      captureException(err, {
        extra: {
          fingerprint: 'useAppHubUsers-crmSearch',
          userIds
        }
      });
    }
  });
  const usersRecord = useMemo(() => {
    var _data$APP_HUB_USERS_F, _data$APP_HUB_USERS_F2;
    const record = {};
    const results = (_data$APP_HUB_USERS_F = data === null || data === void 0 || (_data$APP_HUB_USERS_F2 = data[APP_HUB_USERS_FIELD]) === null || _data$APP_HUB_USERS_F2 === void 0 ? void 0 : _data$APP_HUB_USERS_F2.results) !== null && _data$APP_HUB_USERS_F !== void 0 ? _data$APP_HUB_USERS_F : [];
    for (const result of results) {
      var _result$properties$hs;
      const userId = Number((_result$properties$hs = result.properties.hs_internal_user_id) === null || _result$properties$hs === void 0 ? void 0 : _result$properties$hs.value);
      if (!isNaN(userId)) {
        var _result$properties$hs2, _result$properties$hs3, _result$properties$hs4, _result$properties$hs5, _result$properties$hs6, _result$properties$hs7;
        record[userId] = {
          email: (_result$properties$hs2 = (_result$properties$hs3 = result.properties.hs_email) === null || _result$properties$hs3 === void 0 ? void 0 : _result$properties$hs3.value) !== null && _result$properties$hs2 !== void 0 ? _result$properties$hs2 : '',
          firstName: (_result$properties$hs4 = (_result$properties$hs5 = result.properties.hs_given_name) === null || _result$properties$hs5 === void 0 ? void 0 : _result$properties$hs5.value) !== null && _result$properties$hs4 !== void 0 ? _result$properties$hs4 : '',
          lastName: (_result$properties$hs6 = (_result$properties$hs7 = result.properties.hs_family_name) === null || _result$properties$hs7 === void 0 ? void 0 : _result$properties$hs7.value) !== null && _result$properties$hs6 !== void 0 ? _result$properties$hs6 : ''
        };
      }
    }
    return record;
  }, [data]);
  return {
    usersRecord,
    loading,
    error
  };
};